const contactOptions = [
  {
    icon: 'ri-phone-line',
    title: '전화 상담',
    desc: '평일 오전 9시 ~ 오후 6시',
    value: '1566-8654',
    href: 'tel:15668654',
    label: '전화 연결',
  },
  {
    icon: 'ri-kakao-talk-fill',
    title: '카카오톡 상담',
    desc: '채팅으로 편리하게 상담 및 서류 제출',
    value: '카카오톡 채팅방',
    href: '#',
    label: '채팅 시작',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '등록 신청',
    desc: '지금 바로 가족간병인으로 등록하기',
    value: '5분 내 빠른 등록',
    href: '/register',
    label: '등록하기',
  },
];

export default function FaqContact() {
  return (
    <section className="w-full py-16 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>CONTACT US</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            원하는 답변을 찾지 못하셨나요?
          </h2>
          <p className="text-sm text-gray-500">
            담당 전문가가 직접 안내해 드립니다. 부담 없이 연락 주세요.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {contactOptions.map((opt) => (
            <div
              key={opt.title}
              className="rounded-2xl border border-gray-100 p-6 flex flex-col items-center text-center bg-white"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-4"
                style={{ backgroundColor: '#e8f5f1' }}
              >
                <i className={`${opt.icon} text-xl`} style={{ color: '#2E7D6B' }}></i>
              </div>
              <p className="text-sm font-bold text-gray-900 mb-1">{opt.title}</p>
              <p className="text-xs text-gray-400 mb-2">{opt.desc}</p>
              <p className="text-sm font-semibold mb-4" style={{ color: '#2E7D6B' }}>{opt.value}</p>
              <a
                href={opt.href}
                className="w-full py-2.5 rounded-lg text-sm font-semibold text-center cursor-pointer transition-all"
                style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B' }}
              >
                {opt.label}
              </a>
            </div>
          ))}
        </div>

        {/* Bottom notice */}
        <div
          className="rounded-2xl px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-5"
          style={{ backgroundColor: '#1a3d35' }}
        >
          <div>
            <p className="text-white font-bold text-base mb-1">코리아케어러스와 함께라면 간병보험 청구, 어렵지 않습니다.</p>
            <p className="text-white/60 text-sm">등록부터 청구까지 전 과정을 담당자가 함께합니다.</p>
          </div>
          <a
            href="/register"
            className="flex-shrink-0 px-7 py-3 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all"
            style={{ backgroundColor: '#2E7D6B', color: '#fff' }}
          >
            <i className="ri-arrow-right-line mr-2"></i>
            지금 등록하기
          </a>
        </div>
      </div>
    </section>
  );
}
